import types from "./types";
import { postData } from "../../utils/fetch-requests";

// user
const fetchUser = id => dispatch => {
  fetch(`/api/user/fetch-details/${id}`)
    .then(res => res.json())
    .then(user => {
      dispatch({
        type: types.RECEIVE_USER_DETAILS,
        payload: user
      });
      dispatch({ type: types.FINISH_USER_DETAILS_LOADING });
    });
};

export {
  fetchUser,
};
